import React from 'react';
import CheckboxToggler from '../checkbox-toggler';

const TogglePins = props => {
    return (
        <CheckboxToggler checked={props.checked} onChange={() => {
            props.onChange(!props.checked);
        }} label={props.label} />
    );
};

export default TogglePins;
